import React from 'react';
import { Card, Flex, Heading, Text } from '@zillow/constellation-10';
import { ePages } from 'src/utilities/ePages';
import Link from 'next/link';
import { useIsSpruce } from 'src/hooks/useIsSpruce';

const paymentTypes: { name: string; getDescription: (brandName: string) => string; url: string; }[] = [
  {
    name: 'Earnest Money Deposit',
    getDescription: () => `Pay your contract deposit online or access payment instructions.`,
    url: ePages.EasyPayAccessCode,
  },
  {
    name: 'Closing Funds',
    getDescription: (brandName: string) => `Access payment instructions to submit closing funds to ${brandName}.`,
    url: ePages.C2CStatePicker,
  },
];

export const PaymentTypeSelection: React.FC = () => {
  const isSpruce = useIsSpruce();
  const brandName = isSpruce ? 'Spruce' : 'Zillow Closing';
  return (
    <Flex css={{ display: 'flex', gap: 'sm', flexDirection: { sm: 'column', md: 'row' } }}>
      {paymentTypes.map((paymentTypes, index) => (
        <Card
          asChild
          css={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 'xs' }}
          key={paymentTypes.name}
          interactive
          outlined={false}
          data-testid={`payment-type-selection-card-${paymentTypes.name.toLowerCase().replaceAll(' ', '-')}`}
        >
          <Link href={paymentTypes.url}>
            <Card.Header divider={false} css={{ marginBottom: 'xs' }}>
              <Heading level={3}>{paymentTypes.name}</Heading>
            </Card.Header>
            <Text>{paymentTypes.getDescription(brandName)}</Text>
          </Link>
        </Card>
      ))}
    </Flex>
  );
};
